<rte-editor
  [formControl]="control"
  (focusout)="onBlur.emit()"
></rte-editor>
